// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Styles from "../../styles/components/Styles.bs.jsx";
import * as JsxRuntime from "react/jsx-runtime";
import OnboardingTemplateModuleCss from "./OnboardingTemplate.module.css";

let classes = OnboardingTemplateModuleCss;

function OnboardingTemplate(props) {
  return <div
    aria-hidden={props.loadingOverlay}
    className={Styles.page.centered + ` ` + classes.root}
  >
    <h1
      className={Styles.utility.srOnly}
    >
      {"Check.beer"}
    </h1>
    {props.children}
  </div>;
}

let make = OnboardingTemplate;

export {
  classes,
  make,
}
/* classes Not a pure module */
